import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { useState } from 'react';

type FilterDrawerAccordionProps = {
  readonly title: string;
  readonly children: React.ReactNode;
  readonly expanded?: boolean;
};

export const FilterDrawerAccordion = ({ title, children, expanded }: FilterDrawerAccordionProps) => {
  const [isExpanded, setIsExpanded] = useState(expanded ?? false);

  return (
    <Accordion
      variant="elevation"
      sx={{
        border: 'none',
        '&:before': {
          display: 'none',
        },
      }}
      disableGutters
      slotProps={{ heading: { sx: { '& > button': { paddingLeft: 0 } } } }}
      expanded={isExpanded}
    >
      <AccordionSummary expandIcon={<ExpandMore />} onClick={() => setIsExpanded((exp) => !exp)}>
        <Typography variant="labelLight" fontWeight="bold">
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};
